module.exports = __webpack_public_path__ + "static/img/4.c818741.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/eng/4.png
// module id = I+QW
// module chunks = 0